import { gql } from '@apollo/client';

export const GET_MONITORING_FORM_SUBMISSION = gql`
  query GetMonitoringFormSubmission($id: ID!) {
    monitoringFormSubmission: getMonitoringFormSubmission(id: $id) {
      id
      periodNumber
      monitoringForm {
        id
        name
        indicators {
          id
          indicator {
            id
            name
            dimensions {
              id
              index
              name
            }
          }
          dimensions
          site {
            id
            name
          }
        }
        users {
          user {
            id
            firstName
          }
          sites {
            id
          }
          formRole {
            id
            name
          }
        }
        reporterSubmissions {
          id
          updatedAt
          status
          statusDate
          periodNumber
          reporter {
            id
            funder {
              id
              name
            }
            serviceProvider {
              id
              name
            }
            institution {
              id
              name
            }
          }
          respondent {
            id
            lastName
            firstName
            email
          }
        }
        reporters {
          id
          funder {
            id
            name
          }
          serviceProvider {
            id
            name
          }
          institution {
            id
            name
          }
        }
        formReporters {
          id
          sites {
            id
          }
          organisation {
            id
            funder {
              id
              name
            }
            serviceProvider {
              id
              name
            }
            institution {
              id
              name
            }
          }
        }
      }
      data {
        id
        submission {
          id
          status
          urls {
            id
            link
            name
          }
        }
        indicator {
          id
          name
        }
        periodNumber
        dimensionReporter {
          id
          funder {
            id
            name
          }
          serviceProvider {
            id
            name
          }
          institution {
            id
            name
          }
        }
        dimension1
        dimension2
        dimension3
        dimension4
        dimension5
        value
        site {
          id
          name
        }
      }
    }
  }
`;
